<template>
  <div class="full">
    <div class="cover">
      <h1 class="loading">Diskette einwerfen</h1>
      <img id="disc" src="@/assets/diskette.png" @click="triggerFileInput" />
    </div>
    <input
      type="file"
      @change="loadFile"
      ref="fileInput"
      style="display: none"
    />
  </div>
</template>

<script>
import store from "@/store"; // Pfad zu deinem Vuex Store
import { mapGetters } from "vuex";

export default {
  name: "Init",
  computed: {
    ...mapGetters(["isBrowserGame"]),
  },
  mounted() {
    if (this.isBrowserGame) {
      const gamedata = require(`@/data/web.json`);
      store.dispatch("loadData", gamedata); // 'loadData' ist die Vuex-Action
    }
  },
  methods: {
    loadFile(event) {
      const file = event.target.files[0];
      this.$store.dispatch("setMusic", "loading.mp3");
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          try {
            const data = JSON.parse(e.target.result);
            console.log(data);
            store.dispatch("loadData", data); // 'loadData' ist die Vuex-Action
          } catch (error) {
            console.error("Fehler beim Parsen der JSON-Datei:", error);
          }
        };
        reader.readAsText(file);
      }
    },
    triggerFileInput() {
      // Trigger für das echte File-Input-Element
      this.$refs.fileInput.click();
    },
  },
};
</script>
<style scoped lang="scss">
@import "../scss/_variables.scss";
@import "../scss/_shared_private.scss";

.full {
  position: absolute;
  width: 100%;
  height: 100%;
  background: #e5007e;
}
$disc: $height / 1.3;
#disc {
  height: $disc;
  width: auto;
  filter: drop-shadow(1px 5px 5px rgba(0, 0, 0, 0.55));
  z-index: 100;
  cursor: pointer;
}
.text {
  top: 0;
  height: 20px;
  width: 100%;
  position: absolute;
  z-index: 100;
  text-align: center;
}
$h1: 20px * 0.6;
span.install {
  text-align: center;
  flex-direction: column;
  font-size: $h1;
  line-height: 20px;

  font-family: lores-15-narrow, sans-serif;
  font-weight: 400;
  font-style: normal;
  color: white;
  margin: 0px;
}

.expand {
  height: $height-full !important;
  transition: all 3s;
  transform: translateY(-$height);
}
.inject {
  transition: all 2s ease-in;
  transform: translateY(-$height);
}
.waiting {
  z-index: 100;
}
h1.loading {
  z-index: 100;
  flex-direction: column;
  font-size: $tip;
  font-family: lores-15-narrow, sans-serif;
  font-weight: 400;
  font-style: normal;
  color: white;
}
</style>
